import * as React from 'react'
import {Blocks} from '@builder.io/sdk-react'
import {cn} from '@/lib/utils'
import type {TabBoxProps} from './TabButtonBox'

export const TabPanelBox = ({
    attributes,
    content = [],
    builderBlock,
    'data-testid': dataTestId
}: TabBoxProps) => {
    const {className, ...restAttributes} = attributes || {}

    return (
        <div
            className={cn('flex flex-col px-4 py-3', className)}
            {...restAttributes}
            data-testid={dataTestId || 'contentTabs-TabPanelBox'}
        >
            <Blocks
                path="component.options.content"
                blocks={content}
                parent={builderBlock?.id}
                data-testid="contentTabs-TabPanelBox-Blocks"
            />
        </div>
    )
}

TabPanelBox.displayName = 'TabPanelBox'
